import React, { Component } from 'react';

import '../css/mapa.css'

class Mapa extends Component {
  render() {
    return (
      <div className="container mt-4">
        <div className="textomarcas row align-items-center no-gutters">
          <div className="col">
            Donde estamos ubicados
          </div>
        </div>
        <div className="row">
          <div className="col">
            <div className="google-maps">
              <iframe src="https://www.google.com/maps/embed?pb=!1m16!1m12!1m3!1d31918.510956892696!2d-78.4427614488378!3d-0.08558089248161815!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!2m1!1sFerreteria%20Padilla!5e0!3m2!1ses!2sec!4v1567054052643!5m2!1ses!2sec" frameborder="0" allowfullscreen=""></iframe>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default Mapa;
